<template>
  <div>
    <el-row style="margin-top: 20px;">
      <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style="text-align: right;">大屏标题：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15">
        <el-input
          v-model="bigScreenTitleData.val1"
          placeholder="请输入大屏标题"
          size="mini"
          style="width: 70%">
        </el-input>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="text-align: right;">大屏简称：</el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-input
          placeholder="请输入大屏简称"
          v-model="bigScreenAbbreviationData.val1"
          size="mini"
          style="width: 70%">
        </el-input>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "editBigScreenTitle",
  props: {
    bigScreenTitleData:{},
    bigScreenAbbreviationData: {},
  },
}
</script>

<style scoped>

</style>
